import confetti from "canvas-confetti";

export const showConfetti = (canvasRef) => {
    setTimeout(showEmojiMoneyConfetti, 800);

    confetti({
        particleCount: 80,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 9999
    });

    const duration = 1200;
    const end = Date.now() + duration;

    (function frame() {
        confetti({
            particleCount: 3,
            angle: 60,
            spread: 55,
            origin: { x: 0 },
            shapes: ['square'],
            scalar: 1.4,
            colors: ['#4CAF50'],
        });
        confetti({
            particleCount: 3,
            angle: 120,
            spread: 55,
            origin: { x: 1 },
            shapes: ['square'],
            scalar: 1.4,
            colors: ['#4CAF50'],
        });

        if (Date.now() < end) {
            requestAnimationFrame(frame);
        }
    }());
}

function showEmojiMoneyConfetti() {
    const container = document.getElementById('money-confetti-container');
    const emojiCount = 25;
    const duration = 3500;

    for (let i = 0; i < emojiCount; i++) {
        const emoji = document.createElement('span');
        emoji.innerText = '💵';
        emoji.style.position = 'absolute';
        emoji.style.fontSize = `${24 + Math.random() * 16}px`;
        emoji.style.left = `${Math.random() * 100}vw`;
        emoji.style.top = '-1em';
        emoji.style.transition = `transform ${duration}ms cubic-bezier(0,1,1,1), opacity 3s`;
        emoji.style.transform = `translateY(0) rotate(${(Math.random() - 0.5) * 90}deg)`;
        emoji.style.opacity = 1;
        emoji.style.zIndex = 9999
        container.appendChild(emoji);

        // Animate after next paint
        setTimeout(() => {
            emoji.style.transform = `translateY(${60 + Math.random() * 20}vh) rotate(${(Math.random() - 0.5) * 180}deg)`;
            emoji.style.opacity = 0;
        }, 200);

        // Remove after animation
        setTimeout(() => {
            emoji.remove();
        }, duration + 500);
    }
}